<div class="min-h-screen flex items-center justify-center bg-gray-50">
  <div class="text-center max-w-md mx-auto px-6">
    <!-- 404 Icon/Illustration -->
    <div class="mb-8">
      <i
        class="pi pi-exclamation-triangle text-red-500 block"
        style="font-size: 50px !important"
      ></i>
    </div>

    <!-- Error Code -->
    <div class="error-code text-8xl sm:text-6xl font-bold text-gray-800 mb-4">
      404
    </div>

    <!-- Error Message -->
    <div class="text-3xl sm:text-2xl font-semibold text-gray-700 mb-4">
      Page Not Found
    </div>

    <!-- Error Description -->
    <div class="text-lg sm:text-base text-gray-600 mb-8 leading-relaxed">
      Sorry, the page you are looking for doesn't exist or has been moved.
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col sm:flex-row gap-4 justify-center mb-8">
      <p-button
        label="Login"
        icon="pi pi-home"
        styleClass="p-button-raised p-button-primary px-6 py-3 font-medium bg-blue-600 border-blue-600 hover:bg-blue-700 hover:border-blue-700"
        (onClick)="goToHome()"
      >
      </p-button>

      <p-button
        label="Back"
        icon="pi pi-arrow-left"
        styleClass="p-button-raised p-button-secondary px-6 py-3 font-medium bg-gray-600 border-gray-600 text-white hover:bg-gray-700 hover:border-gray-700"
        (onClick)="goBack()"
      >
      </p-button>
    </div>

    <!-- Additional Help -->
    <div class="text-sm text-gray-500">
      <p class="mb-0">
        If you believe this is an error, please contact support.
      </p>
    </div>
  </div>
</div>
